import React from 'react';
import { ProductItemProps } from '../../../../models/Product';
import { Page, useExecutiveCheckupRouter } from '../../router/context';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { ScheduleItemPropsBuilder } from '../../../../models/Schedule';
import { ProductSelectorTemplate } from '../../../../templates/ProductSelectorTemplate';
import { useServiceContext } from '../../../../contexts/ServiceContext';

export function ProductList(state: any) {
  const { goBack, navigate } = useExecutiveCheckupRouter();
  const { changeSchedule, selectedItem: schedule } = useScheduleContext();
  const { selectedService } = useServiceContext();

  function sortProductsByName(products: ProductItemProps[]) {
    return products.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });
  }

  const productList = React.useMemo(() => {
    let productToTop: ProductItemProps | undefined;
    const sortedProducts = sortProductsByName(selectedService?.products).filter(item => {
      if (item.name.toUpperCase().includes('CLÍNICO GERAL')) {
        productToTop = item;
        return false;
      }
      return true;
    });
    if (productToTop) return [productToTop, ...sortedProducts];
    return sortedProducts;
  }, [selectedService?.products]);

  function productName(name: string) {
    return (name.split(' - ')[1] || name).trim();
  }

  function createSchedule(product: ProductItemProps) {
    const scheduleFactory = ScheduleItemPropsBuilder();
    scheduleFactory.setProduct({ ...product, name: productName(product.name) });

    changeSchedule({ ...schedule, ...scheduleFactory.build() });
  }

  const handleSubmit = () => {
    navigate(Page.APPOINTMENT_TYPE, { ...state });
  };

  return (
    <>
      <ProductSelectorTemplate
        headTitle="Quais consultas deseja agendar?"
        products={productList}
        handleProducts={_ => handleSubmit()}
        handleSelectProduct={product => createSchedule(product)}
        // goBack={goBack}
      />
    </>
  );
}
